__turbopack_context__.v({
  "image": "AiInRecruitingImplementationSection-module__wJQsma__image",
  "imageWrapper": "AiInRecruitingImplementationSection-module__wJQsma__imageWrapper",
  "implementationSection": "AiInRecruitingImplementationSection-module__wJQsma__implementationSection",
  "item": "AiInRecruitingImplementationSection-module__wJQsma__item",
  "itemDesc": "AiInRecruitingImplementationSection-module__wJQsma__itemDesc",
  "itemOuter": "AiInRecruitingImplementationSection-module__wJQsma__itemOuter",
  "itemTitle": "AiInRecruitingImplementationSection-module__wJQsma__itemTitle",
  "number": "AiInRecruitingImplementationSection-module__wJQsma__number",
  "sectionSubtitle": "AiInRecruitingImplementationSection-module__wJQsma__sectionSubtitle",
  "sectionTitle": "AiInRecruitingImplementationSection-module__wJQsma__sectionTitle",
});
